/** Exports carry `https://<tenant>/d?u=<bucket url>`: a login-gated link that never expires. */
export const DOCUMENT_ROUTE_PREFIX = '/d?'
/** An app asks the signed-in person to approve it: `/connect?flow=<signed flow>`. */
export const CONNECT_ROUTE_PREFIX = '/connect?'
const INTENDED_PATH_KEY = 'fto:intendedPath'
const RETURN_PATH_KEY = 'fto:returnPath'
const RETURNABLE_PREFIXES = [DOCUMENT_ROUTE_PREFIX, CONNECT_ROUTE_PREFIX]

export function isDocumentPath(path: string | null | undefined): boolean {
  return !!path && path.startsWith(DOCUMENT_ROUTE_PREFIX)
}

export function isReturnablePath(path: string | null | undefined): path is string {
  return !!path && RETURNABLE_PREFIXES.some((prefix) => path.startsWith(prefix))
}

/** After login, land on the document the person clicked instead of the home page. */
export function consumeIntendedDocumentPath(storage: Storage = sessionStorage): string | null {
  const intended = storage.getItem(INTENDED_PATH_KEY)
  if (!isDocumentPath(intended)) return null
  storage.removeItem(INTENDED_PATH_KEY)
  return intended
}

/** Written only when a returnable page is sent to sign in: `fto:intendedPath` is rewritten on every navigation. */
export function rememberReturnPath(path: string, storage: Storage = sessionStorage): void {
  if (!isReturnablePath(path)) return
  try { storage.setItem(RETURN_PATH_KEY, path) } catch { /* no-op */ }
}

/** After login, land on the page the person was sent from instead of the home page. */
export function consumeReturnPath(storage: Storage = sessionStorage): string | null {
  const remembered = storage.getItem(RETURN_PATH_KEY)
  storage.removeItem(RETURN_PATH_KEY)
  return isReturnablePath(remembered) ? remembered : consumeIntendedDocumentPath(storage)
}
